export * from './lib/analytics.module';
export * from './lib/analytics-base';
export * from './lib/analytics.types';
export * from './lib/analytics-global';
export * from './lib/analytics.types';
export * from './lib/analytics.directive';
export * from './lib/analytics-context';

// remove after moving the relevant components to the libraries
export * from './shared/team-members.analytics';
export * from './shared/notifications.analytics';
export * from './shared/profile.analytics';
export * from './shared/tags.analytics';
export * from './shared/events.analytics';
export * from './shared/calendar.analytics';
export * from './shared/guides.analytics';
export * from './shared/quick-evaluations.analytics';

export { AnalyticsSegmentClient } from './lib/analytics-segment-client';
